import { Button, Form, NumberBox, SelectBox, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import { apiGetA, apiGetP, apiPostA, apiPostP, toLowerKeys } from '../../GanjiTools';
import { UniGrid } from '../UniGrid';
import ExportTool from './ExportTool';
import CollapsibleBox from '../utils/CollapsibleBox';
import { style } from 'typestyle';
import Theme from '../theme/Theme';
import SideDivider from '../layout/SideDivider';
import Missions from './Missions';

class TruckOwnerReports extends Component {
    state = {
        truckOwner: this.props.truckOwner,
        //truckOwnersLookup: window.truckOwnersLookup ?? [],
        receivables: 0, payments: 0, moneyBalance: 0,
        loading: true,
        missions: [],
        totalFreight: 0,
    }

    static fetchTruckOwnersLookupP(forceReload) {
        return new Promise((resolve, reject) => {
            if (window.user?.role === 'ماشین دار') {
                window.truckOwnersLookup = [{ ...window.user, id: window.user.linkedrecord_rowid % 1000000 }];
                resolve?.(window.truckOwnersLookup);
                return;
            }

            if (!forceReload && window.truckOwnersLookup?.length > 0) {
                resolve?.(window.truckOwnersLookup);
                return;
            }
            apiPostP('/api/dyna/rowsAsLookup/TruckOwner', {})
                .then(res => {
                    let { list, error } = res ?? { error: 'No response' };
                    if (error?.length > 0) {
                        reject?.(error);
                        return;
                    }
                    window.truckOwnersLookup = list;
                    resolve?.(list);
                    console.log('truckOwnersLookup=', truckOwnersLookup);
                }).catch(reject)
        });
    }

    loadTruckOwnerMissions = (id, forceUpdate) => {
        apiGetP(`/api/parssaman/truckOwnerMissions/${id ?? 0}`)
            .then(res => {
                let { error = 'No response.', list = [], totalFreight = 0 } = res ?? {};

                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.state.missions = list ?? [];
                this.state.totalFreight = totalFreight;

                if (forceUpdate)
                    this.forceUpdate();
            }).catch(window.notif(error));
    }

    loadTruckOwnerReport = (id, whenDone) => {
        apiGetP(`/api/parssaman/report/truckOwner/${id}`)
            .then(res => {
                let { error = 'No response.', receivables, payments, missions } = res ?? {};

                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ receivables, payments, missions, moneyBalance: receivables - payments }, whenDone);
            })
            .catch(window.notif);
    }

    onSelectedTruckOwnerChanged = id => {
        let truckOwner = window.truckOwnersLookup.find(x => x.id === id);
        this.setState({ truckOwner }, () => this.loadTruckOwnerReport(id, () => this.props.onSelectedTruckOwnerChanged?.(truckOwner)));
    }

    componentDidMount() {
        Promise.all([
            TruckOwnerReports.fetchTruckOwnersLookupP(true),
            apiGetP('/api/dyna/cols/mission')
        ]).then(([_, res]) => {
            const { error, list } = res ?? { error: 'No response.' };

            if (error?.length > 0) {
                window.config(error);
                return;
            }
            this.state.missionColumns = toLowerKeys(list?.map(c => ({ ...c, caption: c.caption_FA ?? c.name })) ?? []);
            if (window.truckOwnersLookup?.length === 1) {
                this.state.truckOwner = window.truckOwnersLookup[0];
                this.loadTruckOwnerReport(this.state.truckOwner.id);
            }
        }).catch(window.notif)
            .finally(() => this.setState({ loading: false }));

        //     TruckOwnerReports.fetchtruckOwnersLookupP(true)
        //         .then(() => this.setState({ loading: false }))
        //         .catch(console.log);
        //     apiGetP('/api/dyna/cols/mission')
        //         .then(res => {
        //             let { error = 'No response.', list } = res ?? {};
        //             if (error?.length > 0) {
        //                 window.config(error);
        //                 return;
        //             }
        //             this.setState({ missionColumns: toLowerKeys(list) });
        //         }).catch(window.notif);
        //     //.then(truckOwnersLookup => this.setState({ truckOwnersLookup }));
    }

    render() {
        if (this.state.loading)
            return (
                <p style={{ padding: '3rem' }}> صبر کنید...</p>
            );

        let title = 'نمایش سوابق', summary = '', width = this.props.width ?? `${SideDivider.bodyWidth - 150}px`;

        return (
            <div style={{ padding: '0 3rem' }}>
                <CollapsibleBox className={'loadorder-collapsibleboxd ' +
                    style({
                        background: Theme.col1('whitesmoke'),
                        borderRadius: '1rem',
                        color: Theme.col0()
                    })
                }
                    style={{ width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}

                    title={
                        <div className='loadorder-title'
                            style={{
                                height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                                justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                            }}
                        >
                            <span style={{ fontWeight: '900' }}>{title}</span>
                        </div>
                    }
                    headerStyle={{
                        width: `calc(${width} - ${this.props.wizardMode ? -2 : 2}rem)`,
                        background: Theme.col1('whitesmoke'),
                        color: Theme.col0(),
                    }}
                    summary={
                        <span className='loadorder-summary'
                            style={{
                                margin: '0 1rem',
                                fontSize: '0.8rem',
                                color: Theme.col2('#550')
                            }}
                        >
                            {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                        </span>
                    }

                    bodyStyle={{
                        ...this.props.style, ...this.stl, marginTop: '0',
                        borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                        width: `calc(${width} - 2rem)`,
                        background: Theme.col1('whitesmoke'),
                    }}>
                    <Form rtlEnabled colCount={60} width={`calc(${width} - 2rem)`} labelLocation={window.mView ? 'top' : 'left'}>
                        <SimpleItem colSpan={60} label={{ text: 'انتخاب ماشین دار' }}>
                            <SelectBox rtlEnabled items={window.truckOwnersLookup} valueExpr='id' displayExpr='summary'
                                value={this.state.truckOwner?.id}
                                onValueChanged={e => this.onSelectedTruckOwnerChanged(e.value)}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <SimpleItem colSpan={60}>
                            <UniGrid rows={this.state.missions} columns={this.state.missionColumns} readOnly noMetaGrid // table='Mission'
                                focusedRowEnabled={false}
                                title='مأموریت ها' titleFontSize={window.mView ? '1rem' : '1.2rem'} height='20rem'  //paging={false}
                                hideFields={['fk_truckowner', 'id', 'datebargiri', 'totalfreight', 'status', 'profit',
                                    'tankerfreight', 'tankerfreightunit', 'phee', 'pheeunit'
                                ]}
                                customCellRender={{
                                    fk_truck: x => <span>{x.displayValue?.split(':')?.[1]}</span>,
                                    tankerfreight: Missions.renderCurrencyCell,
                                    carfreight: Missions.renderCurrencyCell,
                                    ladingbill: Missions.renderCurrencyCell,
                                    phee: Missions.renderCurrencyCell,
                                    profit: Missions.renderCurrencyCell,
                                }}
                            //field='fK_TruckOwner' equalTo={this.state.truckOwner?.id} field='fK_TruckOwner' equalTo={this.state.truckOwner?.id}
                            // fieldEqualities={{ fK_TruckOwner: `=${this.state.truckOwner?.id ?? 0}` }}
                            //hideFields={['fK_TruckOwner']}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={60}>
                            <UniGrid table='Deal' readOnly noMetaGrid title='پرداخت ها'
                                titleFontSize={window.mView ? '1rem' : '1.2rem'}
                                //field='fK_TruckOwner' equalTo={this.state.truckOwner?.id}
                                fieldEqualities={{ fK_TruckOwner: `=${this.state.truckOwner?.id ?? 0}` }}
                                hideFields={['fK_TruckOwner', 'fK_Customer', 'ware', 'date']}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع مطالبات ها' }} colSpan={window.mView ? 60 : 30}>
                            <NumberBox readOnly key={'nbi_' + this.state.receivables} format=',##0'
                                value={this.state.receivables ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع پرداختی ها' }} colSpan={window.mView ? 60 : 30}>
                            <NumberBox readOnly key={'nbo_' + this.state.payments} format=',##0'
                                value={this.state.payments ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'تراز مالی' }} colSpan={60}>
                            <NumberBox readOnly format=',##0'
                                value={this.state.moneyBalance ?? 0}
                            />
                        </SimpleItem>
                    </Form>
                </CollapsibleBox>

                {['ادمین', 'اپراتور'].includes(window.user?.role) && this.state.truckOwner?.id > 0 &&
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button text='پرداخت به ماشین دار' width={window.mView ? '100%' : '12rem'} type='success'
                            onClick={() => this.props.onDeal?.(1, this.state.truckOwner)}
                        />
                    </div>
                }

                <div style={{ margin: '2rem 0 1rem 0', color: 'gray' }}>
                </div>

                <ExportTool table='deal' width={width} fileName='گزارش صاحب ماشین'
                    excludeFields={['fK_Tanker', 'fK_TruckOwner', 'fK_Customer', 'ware', 'dealType']}
                    extraFieldEqualities={[
                        { name: 'dealType = 1', oper: 'pre_rendered' },//{ name: 'dealType', oper: '=', value1: 1, nature: 'number' },
                        { name: 'fK_TruckOwner = ' + this.state.truckOwner?.id, oper: 'pre_rendered' } //{ name: 'fK_TruckOwner', oper: '=', value1: this.state.truckOwner?.id, nature: 'number' }
                    ]}
                />
            </div>
        );
    }
}

export default TruckOwnerReports;